import { useState } from "react";
import { useSchemaForm } from "@/components/form";
import { notify } from "@/shared/notification";
import { useAddDocumentoElectronicoMutation } from "@/features/facturacion-electronica/api/add-documento-electronico";
import { NotaRemisionForm, notaRemisionFormSchema } from "@/features/facturacion-electronica/components/nota-remision-form";
import { useEmisorConfig } from "@/features/facturacion-electronica/hooks/use-emisor-config";
import { buildNotaRemisionRequest } from "@/features/facturacion-electronica/utils/de-request-builder";
import { DEPageLayout } from "@/features/facturacion-electronica/components/de-page-layout";
import { DE_SUCCESS_MESSAGES } from "@/features/facturacion-electronica/utils/de-form-utils";
import { Cliente } from "@/shared/types/cliente";
import { NotaRemisionFormData } from "@/features/facturacion-electronica/utils/de-types";
import { openPdfFromBase64 } from "@/features/facturacion-electronica/utils/pdf-utils";

export default function NuevaNotaRemisionPage() {
    return (
        <DEPageLayout title="Nueva Nota de Remisión">
            <AddNotaRemisionForm />
        </DEPageLayout>
    );
}

function AddNotaRemisionForm() {
    const mutation = useAddDocumentoElectronicoMutation();
    const { config } = useEmisorConfig();
    const [cliente, setCliente] = useState<Cliente | null>(null);

    const form = useSchemaForm({
        schema: notaRemisionFormSchema,
        onSubmit: async ({ value, formApi }) => {
            const deRequest = buildNotaRemisionRequest(value as unknown as NotaRemisionFormData, config!);
            const result = await mutation.mutateAsync(deRequest);
            notify(DE_SUCCESS_MESSAGES.notaRemision);

            if (result.kuDEBase64)
                openPdfFromBase64(result.kuDEBase64);

            formApi.reset();
            setCliente(null);
            formApi.setFieldValue("clienteId", "", { dontUpdateMeta: true });
            formApi.setFieldValue("items", [], { dontUpdateMeta: true });
            formApi.setFieldValue("motivoEmisionNR", "1", { dontUpdateMeta: true });
            formApi.setFieldValue("responsableEmision", "1", { dontUpdateMeta: true });
            formApi.setFieldValue("kmRecorrido", 1, { dontUpdateMeta: true });
            formApi.setFieldValue("tipoDocumentoAsociado", "1", { dontUpdateMeta: true });
        },
    });

    return (
        <NotaRemisionForm
            form={form}
            onClienteChange={setCliente}
            cliente={cliente}
            flex={1}
        />
    );
}
